<div class="container">
  <mic-breadcrumb id="finished-product-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('plantSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="flex items-center justify-between mb-4 action-row">
    <h2 class="page-title m-0" id="plant-setup-heading">{{ translationService.translate('plantSetupText') }}</h2>
    <button id="new-plant-button" type="button" mat-flat-button color="primary" (click)="addNewPlant()">
      <mat-icon>add</mat-icon> {{ translationService.translate('addText') }}
    </button>
  </div>

  <div class="cam-table mt-2 ml-2">
    <mic-table appCopyOnSelect class="table-stripped" [config]="tableConfig" [dataSource]="plants">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'status'">
        <div class="flex flex-row gap-1">
          @if (item.plantActive === 'Y') {
          <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
          } @if (item.plantActive === 'N') {
          <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
          }
        </div>
      </ng-container>
    </mic-table>
  </div>
</div>
